import React from 'react';
import { X, Trash2 } from 'lucide-react';
import * as S from "./style";
const DeleteModal = ({ isOpen, onClose, onConfirm, itemName }) => {
  if (!isOpen) return null; 

  return (
    <S.Overlay onClick={onClose}>
      <S.Content onClick={(e) => e.stopPropagation()}>
        <button className="close-x" onClick={onClose}>
          <X size={20} />
        </button>

        <header>
          <div className="icon-box">
            <Trash2 size={32} />
          </div>
          <h3>Confirmar Exclusão</h3>
        </header>

        <p>
          Tem certeza que deseja remover este item?
          <strong>{itemName}</strong>
        </p>

        <div className="modal-actions">
          <button className="cancel-btn" onClick={onClose}>
            Não, cancelar
          </button>
          <button className="confirm-btn" onClick={onConfirm}>
            Sim, excluir
          </button>
        </div>
      </S.Content>
    </S.Overlay>
  );
};

export default DeleteModal;